import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SavePlayerInput_InputAdapter_instance3cegmft9cv7tf as SavePlayerInput_InputAdapter_instance } from '../type/adapter/SavePlayerInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePlayerMutation_VariablesAdapterClass;
function SavePlayerMutation_VariablesAdapter() {
  if (SavePlayerMutation_VariablesAdapterClass === VOID) {
    class $ {
      d6i(writer, value, customScalarAdapters, withDefaultValues) {
        writer.h48('input');
        obj(SavePlayerInput_InputAdapter_instance).f40(writer, customScalarAdapters, value.c6i_1);
      }
    }
    initMetadataForObject($, 'SavePlayerMutation_VariablesAdapter');
    SavePlayerMutation_VariablesAdapterClass = $;
  }
  return SavePlayerMutation_VariablesAdapterClass;
}
var SavePlayerMutation_VariablesAdapter_instance;
function SavePlayerMutation_VariablesAdapter_getInstance() {
  return SavePlayerMutation_VariablesAdapter_instance;
}
//region block: init
SavePlayerMutation_VariablesAdapter_instance = new (SavePlayerMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  SavePlayerMutation_VariablesAdapter_instance as SavePlayerMutation_VariablesAdapter_instance3ezv956cbflo8,
};
//endregion

//# sourceMappingURL=SavePlayerMutation_VariablesAdapter.mjs.map
